exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.row-fix[data-v-41a797c2] {\r\n  margin-left: 0;\r\n  margin-right: 0;\n}\n.row-fix .row[data-v-41a797c2] {\r\n  margin-left: 0;\r\n  margin-right: 0;\n}\r\n", ""]);

// exports
